module.exports = __webpack_public_path__ + "img/man.603369c0.svg";